import React, { Component } from 'react';
import {
   UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  NavbarBrand,
  Form,
  InputGroup,
  InputGroupButton,
  Input,

} from 'reactstrap';

import HeaderDropdown from './HeaderDropdown';

class Header extends Component {

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    // -- set URL
    const url = window.location.host.split(':');
    
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler>
        <NavbarBrand href="#"></NavbarBrand>
        {url[0] == 'admin.mydp.smartceptation.nl' ? <span style={{color: 'white', fontWeight: 'bold', paddingLeft: '20px', fontSize: '20px'}}>Let op, dit is de acceptatieomgeving. <a href="https://admin.mijndp.dp.nl">Klik hier voor de productieomgeving</a></span> : null}
        <Nav className="ml-auto" navbar>
        <HeaderDropdown accnt/>
        </Nav>

        <NavbarToggler className="d-md-down-none" onClick={this.asideToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js